<!-- Destination-driven keys only; the template's own settings are the schema form's. -->
@if (form.controls.thales_fastpath_airline || form.controls.lilt_language_pairs) {
  <div class="row cl-spacing-small" [formGroup]="form">
    <!-- Lilt Translation (item-level: target languages + reference URLs).
         Domain and source language are picked at PO level — see DefaultPoComponent. -->
    @if (form.controls.lilt_language_pairs) {
      <div class="col-12 align-self-start">
        <label class="form-label">Target Languages<span class="required">*</span></label>
        @if (!liltDomain) {
          <p class="form-text">Pick a Lilt domain (top of the form) first.</p>
        } @else if (liltAvailableModels.length === 0) {
          <p class="invalid-feedback d-block">This domain has no en-US source models. Pick a different domain.</p>
        } @else {
          <div>
            @for (m of liltAvailableModels; track m.memory_id) {
              <label class="form-check form-check-inline">
                <input type="checkbox" class="form-check-input"
                       [checked]="isModelSelected(m)"
                       (change)="toggleModel(m)">
                <span class="form-check-label">{{ formatModelLabel(m) }}</span>
              </label>
            }
          </div>
          @if (form.controls.lilt_language_pairs.errors?.required) {
            <p class="invalid-feedback d-block">Pick at least one target language.</p>
          }
        }
      </div>
    }
    @if (form.controls.lilt_reference_urls) {
      <div class="col-12">
        <label for="lilt_reference_urls" class="form-label">Reference files (S3 URLs)</label>
        <textarea id="lilt_reference_urls" class="form-control" rows="3"
          formControlName="lilt_reference_urls" [class.invalid]="showInvalid('lilt_reference_urls')"
          placeholder="s3://bucket/path/script.pdf&#10;s3://bucket/path/glossary.txt"></textarea>
        @if (form.controls.lilt_reference_urls.errors?.invalidS3Url) {
          <p class="invalid-feedback">Each line must be an s3:// URL.</p>
        }
        @if (!form.controls.lilt_reference_urls.errors) {
          <p class="valid-feedback">One s3:// URL per line. Files are copied to the publish bucket and uploaded to Lilt as REFERENCE.</p>
        }
      </div>
    }
    <!-- Lilt Translation END -->
    @if (form.controls.thales_fastpath_airline) {
      <div class="col-12 col-md-4">
        <label for="thales_fastpath_airline" class="form-label">Thales fast-path airline<span class="required">*</span></label>
        <input id="thales_fastpath_airline" type="text" minlength="3" maxlength="3"
          formControlName="thales_fastpath_airline" [class.invalid]="showInvalid('thales_fastpath_airline')">
        @if (form.controls.thales_fastpath_airline.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!form.controls.thales_fastpath_airline.errors) {
          <p class="valid-feedback">ICAO airline code for Thales
          destination</p>
        }
      </div>
    }
  </div>
}
